import React from 'react';
import * as properties from '../../elementsPropertiesItems';
// import elementsProperties from './elementsProperties';
// import htmlToJson from 'html-to-json';
import { isSet } from '../../../../Utils/CommonFunctions';

const Headings = (props)=>{
    const {changeHandler,path,keyParam,elementData,headingTypes} = props;
    let fontHeadingsValue = isSet(elementData.attributes.style[props.keyParam],null)!==null?elementData.attributes.style[props.keyParam]:'h1';    
    //console.log('headingTypes==',headingTypes)
    return(
        <>            
            <div className="selectgroup selectgroup-info">
                {
                    properties.HeadingTypes.map((item,itemIndex)=>{ 
                        let isChecked = false;                       
                        if(item.value === fontHeadingsValue){
                           isChecked = true; 
                        }

                        if(isSet(headingTypes,[]).indexOf(item.value)==-1){
                            return false;
                        }

                        //console.log('isChecked==',isChecked,item.value,fontHeadingsValue)
                        return(
                            <label className="selectgroup-item" key={itemIndex}> 
                                <input type="radio" name="headings" value={item.value} checked={isChecked} className="selectgroup-input" onChange={()=>changeHandler(path,keyParam,item.value)}/>
                                <span className="selectgroup-button">
                                    {item.label}
                                </span>
                            </label>
                        )
                    })
                }                           
            </div>
            
        </>
    )
}

// Headings.defaultProps = {
//     fontHeadingsValue: 'h1',    
// };

export default Headings;